import { combineReducers } from "@reduxjs/toolkit"
import { reducer as formReducer } from "redux-form"

import dataReducer from "../slices/dataSlice"
// import ageVerificationReducer from "../slices/ageVerificationSlice"
import footerNavigationReducer from "../slices/footerNavigationSlice"
import gamesReducer from "../slices/gamesSlice"
import headerNavigationReducer from "../slices/headerNavigationSlice"
// import headerReducer from "./headerReducer"
// import headReducer from "./headReducer"
// import heroSliderReducer from "./heroSliderReducer"
import homePageReducer from "../slices/homePageSlice"
import modalReducer from "../slices/modalSlice"
import signUpReducer from "../slices/signUpSlice"
// import staticPagesReducer from "./staticPagesReducer"
import toastReducer from "../slices/toastSlice"
import translationsReducer from "../slices/translationsSlice"

const rootReducer = combineReducers({
  data: dataReducer,
  // header: headerReducer,
  modal: modalReducer,
  games: gamesReducer,
  // head: headReducer,
  homePage: homePageReducer,
  // pastEventsPage: pastEventsReducer,
  // promotions: promotionsReducer,
  // promotionsPage: promotionsPageReducer,
  // staticPages: staticPagesReducer,
  signUp: signUpReducer,
  headerNavigation: headerNavigationReducer,
  footerNavigation: footerNavigationReducer,
  // heroSlider: heroSliderReducer,
  toast: toastReducer,
  form: formReducer,
  // ageVerification: ageVerificationReducer,
  translations: translationsReducer
})

export default rootReducer
